import { lazy, Suspense } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";

const WordEditorDemoPage = lazy(
  () => import("@client/components/word-editor-demo/word-editor-demo-page"),
);

export const Route = createFileRoute("/word-editor-demo")({
  component: WordEditorDemoRoute,
});

function WordEditorDemoRoute() {
  return (
    <Suspense
      fallback={
        <div className="flex h-screen items-center justify-center gap-2 bg-background text-muted-foreground">
          <Loader2 className="size-5 animate-spin" aria-hidden="true" />
          <span>正在加载 Word 编辑器…</span>
        </div>
      }
    >
      <WordEditorDemoPage />
    </Suspense>
  );
}
